/** Number.parseFloat with undefined (never NaN) on unparseable input — numeric range/threshold form fields. */
export const parseFloatOrUndefined = (value: string): number | undefined => {
  const parsed = Number.parseFloat(value);
  return Number.isNaN(parsed) ? undefined : parsed;
};

/** Accepts a finite number, or a non-blank string that Number()s to one. */
export const parseEpochNumber = (value: unknown): number | undefined => {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string' && value.trim()) {
    const parsed = Number(value);
    if (Number.isFinite(parsed)) return parsed;
  }
  return undefined;
};

export const isFiniteNumber = (value: unknown): value is number => typeof value === 'number' && Number.isFinite(value);

/** Sums decimal strings ('448.62'), counting unparseable values as zero */
export const sumDecimalStrings = (values: readonly string[]): number => values.reduce((total, value) => total + (parseFloatOrUndefined(value) ?? 0), 0);
